const LogoWhite = () => {
    return (
        <div>
            <img src={"White.png"} alt="logowhite" id={"logowhite"}/>
        </div>
    );
};

export default LogoWhite;